import axios from 'axios';
import { TSavedNodeTamplates } from '@/types/node';
import { AxiosResponse } from 'axios';

export interface IStoredNodeTemplate {
  id?: string;
  title: string;
  description: string;
  picture: string;
  type: string;
  nodes?: { nodes?: TSavedNodeTamplates };
  public: boolean;
}

export const fetchNodeTemplatesService = (): Promise<AxiosResponse<any>> =>
  axios.get(`/api/nodetemplates`);

export const addNodeTemplateService = (
  templateData: IStoredNodeTemplate
): Promise<AxiosResponse<any>> => axios.post(`/api/nodetemplates`, templateData);

export const updateNodeTemplateService = (
  templateData: IStoredNodeTemplate
): Promise<AxiosResponse<any>> =>
  axios.put(`/api/nodetemplates/${templateData.id}`, templateData);

export const deleteNodeTemplateService = (
  templateId: string
): Promise<AxiosResponse<any>> => axios.delete(`/api/nodetemplates/${templateId}`);
